import React from 'react';
import Icon from '../../../components/AppIcon';

const TrustBadges = () => {
  const badges = [
    {
      icon: 'Shield',
      title: 'Conformité RGPD',
      description: 'Vos données sont protégées'
    },
    {
      icon: 'Award',
      title: 'Certifications',
      description: 'Techniciens qualifiés et assurés'
    },
    {
      icon: 'Clock',
      title: 'Disponibilité 24/7',
      description: 'Service d\'urgence garanti'
    },
    {
      icon: 'ShieldCheck',
      title: 'Assurance',
      description: 'Garantie décennale incluse'
    }
  ];

  return (
    <section className="py-16 bg-background">
      <div className="max-w-7xl mx-auto px-4">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-6">
          {badges?.map((badge, index) => (
            <div 
              key={index}
              className="text-center p-6 bg-card border border-border rounded-xl hover:shadow-md transition-shadow"
            >
              <div className="w-12 h-12 mx-auto mb-3 rounded-full bg-primary/10 flex items-center justify-center">
                <Icon name={badge?.icon} size={24} className="text-primary" />
              </div>
              <h3 className="font-semibold text-foreground mb-1">{badge?.title}</h3>
              <p className="text-sm text-muted-foreground">{badge?.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default TrustBadges;